<template>
  <div eagle-form-item="file">
    <file-uploader
      :type="fileType"
      :maxQuantity="maxQuantity"
      :disabled="disabled"
      v-model="data"
    ></file-uploader>
  </div>
</template>

<script lang="babel" type="text/babel">
import formItemMixin from '@/components/form/mixins/formItemMixin'
export default {
  mixins: [formItemMixin],
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.data = window.eagleLodash.cloneDeep(this.storeData)
    },
  },
  computed: {
    fileType() {
      return this.formDataItem.fileType || 'default'
    },
    maxQuantity() {
      return this.formDataItem.maxQuantity || 0
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        if(window.eagleLodash.isEqual(this.data, this.storeData)) return
        this.sync()
      },
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
